import ScrollReveal from 'scrollreveal';

const Reveal = {
    bindEvents: () => {
        let revealElements = document.getElementsByClassName('scroll-reveal');
        if (revealElements.length) {
            Reveal.init();
        }

        let revealDelayElements = document.getElementsByClassName('scroll-reveal-delay');


        if (revealDelayElements.length) {
            Reveal.delayed(revealDelayElements);
        }
    },
    init: () => {
        window.sr = ScrollReveal();
        sr.reveal('.scroll-reveal', {
            duration: 1200,
            origin: 'bottom',
            delay: 300,
            opacity: 0,
            scale: 1,
            distance: '60px',
            afterReveal: function (e) {
                let elm = e;
                //   elm.setAttribute('style', '');
            }
        });
    },
    delayed: (elements) => {

        for (let i = 0; i < elements.length; i++) {
            sr.reveal('.scroll-reveal-delay-' + (i + 1), {
                duration: 1200,
                origin: 'bottom',
                delay: parseInt(elements[i].getAttribute('data-time')),
                opacity: 0,
                scale: 1,
                distance: '60px',
                afterReveal: function (e) {
                    let elm = e;
                    elm.setAttribute('style', '');
                }
            });

        }
    }
};

module.exports = Reveal;



// WEBPACK FOOTER //
// ./src/js/partials/reveal.js